import * as React from "react";
import PbrDocUploader from "src/components/common/PbrDocUploaderTradeId/PbrDocUploader";

const UploadButtonComponent = (props: { e: any; typeTitle: any; setLoading: any; helpers: any }) => {
  const { e, typeTitle, setLoading, helpers } = props;

  return <PbrDocUploader onChangeBase64={val => helpers.handleChange(val, e.data.id, typeTitle)} setLoading={setLoading} hoverText={`Enviar ${typeTitle}`} />;
};

export default UploadButtonComponent;



// WEBPACK FOOTER //
// ./src/pages/monitor/upload/components/UploadButtonComponent.tsx